import { supabaseClient } from './supabaseClient.js';

// Hàm Đăng nhập
export async function loginUser(email, password) {
    console.log(`[API] Đang thử đăng nhập với Email: ${email}`);
    const { data, error } = await supabaseClient.auth.signInWithPassword({
        email: email,
        password: password,
    });

    if (error) {
        console.error('[API] Lỗi đăng nhập:', error.message);
        return { success: false, message: error.message };
    }
    console.log('[API] Đăng nhập thành công! User ID:', data.session.user.id);
    return { success: true, data: data };
}

// Hàm Kiểm tra Session (Phiên đăng nhập)
export async function checkSession() {
    console.log('[API] Đang kiểm tra phiên đăng nhập cũ...');
    const { data } = await supabaseClient.auth.getSession();

    if (data.session) {
        console.log('[API] Tìm thấy Session! Bỏ qua Login.');
        return true;
    }
    console.log('[API] Không có Session. Yêu cầu đăng nhập.');
    return false;
}

// Đăng xuất
export async function logoutUser() {
    console.log('[API] Đang xử lý đăng xuất...');
    const { error } = await supabaseClient.auth.signOut();
    if (error) {
        console.error('[API] Lỗi đăng xuất:', error);
        return false;
    }
    return true;
}

// Lấy Profile người dùng
export async function getUserProfile() {
    const { data: { user } } = await supabaseClient.auth.getUser();
    return user;
}

export async function updateUserPassword(newPassword) {
    const { data, error } = await supabaseClient.auth.updateUser({
        password: newPassword
    });

    if (error) {
        console.error('[API] Lỗi cập nhật mật khẩu:', error.message);
        return { success: false, message: error.message };
    }
    return { success: true };
}

export async function updateUserEmail(newEmail) {
    const { data, error } = await supabaseClient.auth.updateUser({
        email: newEmail
    });

    if (error) {
        console.error('[API] Lỗi cập nhật email:', error.message);
        return { success: false, message: error.message };
    }
    return { success: true, message: 'Check your new email to verify the change.' };
}

export async function resetPasswordForEmail(email) {
    const { data, error } = await supabaseClient.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin
    });

    if (error) {
        console.error('[API] Lỗi quên mật khẩu:', error.message);
        return { success: false, message: error.message };
    }
    return { success: true };
}

export async function verifyCurrentPassword(password) {
    // Verify by fetching current user email, then attempting generic sign-in
    const user = await getUserProfile();
    if (!user) return { success: false, message: 'Not logged in' };

    // We try to sign in. Since we just need to verify, the success means the password is correct.
    const { data, error } = await supabaseClient.auth.signInWithPassword({
        email: user.email,
        password: password
    });

    if (error) {
        return { success: false, message: 'Current password is incorrect.' };
    }
    return { success: true };
}
